// 微信内页面的授权
import { Toast, MessageBox } from 'mint-ui'
import { appUser, storage, whiteList, vconsole_log } from '@/utils'
import { isWeixin } from '@/utils/init/wx'
import { wechatService } from '@/api'
import { pageArgs } from '../common/page-args'
import { getMiniParam } from '@/api/modules/user/mini'
import { $toAppLogin } from '@/utils/common/native-api'
import { getPageUrl } from '@/utils/common/url'
import { $gotoMiniProgram } from '@/utils/common/native-api'
import { saTrack } from '@/utils/common/shence'

// import copyText from '@/utils/clipboard'
// 暴虐新概念的公众号下，获取用户信息
export const hrefIsBnxgn = location.href.indexOf('wx.bnxgn.com') >= 0
;(function () {
  window.onload = function () {
    // 阻止双击放大
    var lastTouchEnd = 0
    document.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    })
    document.addEventListener(
      'touchend',
      function (event) {
        var now = new Date().getTime()
        if (now - lastTouchEnd <= 300) {
          event.preventDefault()
        }
        lastTouchEnd = now
      },
      false
    )
    // 阻止双指放大
    document.addEventListener('gesturestart', function (event) {
      event.preventDefault()
    })
  }
})()

vconsole_log('[页面地址 1.1]', location.href.toString())

// 记录已加载的模块
if (window.loadModules == null) window.loadModules = {}

let state = ''
let code
let getcode = ''
let getcode_test = ''
let copyCode = null // 获取code
let copyErrorCode = null // 调试错误code
const stateParam = {
  state: '',
  data: {},
  getState() {
    const keys = Object.keys(this.data)
    const values = Object.values(this.data)
    this.state = keys
      .map((key, index) => {
        const value = values[index]
        return `${key}:${value}`
      })
      .join(',')
    return encodeURI(`${this.state}`)
  },
  setState(state) {
    this.state = state || ''
    this.data = {}
    this.state.split(',').forEach(v => {
      const [key, value] = v.split(':')
      this.data[key] = value
    })
    return this
  },
  setValue(key, value) {
    this.data[key] = value
    // 查看 state
    console.log('stateParam', stateParam.getState(), stateParam.getValue(key))
    return this
  },
  getValue(key) {
    return this.data[key] || ''
  }
}

// 增加微信授权标识
const setURISearchParams = (redirectUrl, k, v) => {
  const kis = `${k}=`
  const kv = `${k}=${v}`
  const url = new URL(redirectUrl)
  if (url.search.indexOf(kis) === -1) {
    url.search = url.search.indexOf('?') >= 0 ? url.search + '&' + kv : '?' + kv
  } else {
    const args = pageArgs.args()
    const oldkv = `${k}=${args[k]}`
    url.search = url.search.replace(oldkv, kv)
  }
  return url.href
}

// 检查是否是微信环境
export function checkIsWeixin() {
  // 跳过原生环境
  if (appUser.isNative) {
    return
  }
  // if (appUser.token && appUser.userId && !appUser.isWeixin) { return }
  // 引入 wxjssdk

  //企业微信页面不需要wxjsdk
  if (location.href.indexOf('infiniteCardDeductionInfo') !== -1 || location.href.indexOf('userInfo') !== -1) return
  loadJS('//res.wx.qq.com/open/js/jweixin-1.4.0.js', { name: 'jweixin' })

  // 提取 state 和 hash
  const args = pageArgs.args()
  code = args['code']
  getcode = args['getcode']
  getcode_test = args['getcode_test']
  copyCode = args['copyCode']
  copyErrorCode = args['copyErrorCode']
  state = args['state']
  if (state) {
    stateParam.setState(state)
    const hash = stateParam.getValue('hash')
    if (hash) storage.replace(hash) // 从 state 获取
  }
  const userId = args['userId']

  // 初始化 WeiXin User
  appUser.setWeixin(isWeixin(), parseInt(userId || 0))
  let wxstatus = true
  wxstatus = appUser.isWeixin
  if (wxstatus) {
    window.onpageshow = function (event) {
      if (event.persisted) window.location.reload()
    }

    const hasUser = appUser.hasUser()
    const hasWXUser = appUser.hasWXUser()
    vconsole_log('checkIsWeixin1', hasUser, hasWXUser)
    // 【跳过】有效的登录用户
    if (hasUser && hasWXUser) {
      return
    }

    // 没有微信用户，有获取code标识的，是用户拒绝授权
    if (!code && !hasWXUser) {
      if (getcode) {
        return vconsole_log('[Init] checkIsWeixin>', '获取code，被拒绝', 'code: ', code)
      }
    }

    // 【跳过】新用户无授权信息，访问登录白名单页面
    vconsole_log('checkIsWeixin2', !code, !hasUser, whiteList.include())
    if (!code && !hasUser && whiteList.include()) {
      const nextAction = storage.loginNextAction().getItem() // 获取业务操作
      vconsole_log('checkIsWeixin3', nextAction)
      if (nextAction && nextAction.action && hasWXUser) {
        // 已经微信授权的，重新刷新并继续登录
        // storage.loginNextAction().remove() // 同时清除标记
        const canHandleCallback =
          location.hash === '#/pullnew' ||
          location.hash === '#/pullnew2023' ||
          location.hash === '#/pullnew/detail' ||
          location.hash === '#/confirm-pay' // 新用户拉新页面只获取微信的信息 不需要token和userId
        if (canHandleCallback) {
          return
        }
      } else {
        return
      }
    }
    vconsole_log('checkIsWeixin4', 'wechatLogin handle')
    // 微信登录授权
    wechatLogin()
  } else if (appUser.isBrowser) {
    appUser.isNotUserToLogin()
  }
}

// 进行微信授权登录（ authorize, getUserInfo ）
export function wechatLogin(options = {}) {
  // 检查并切换路由视图
  const args = pageArgs.args()
  if (!options.refreshCode) {
    code = args['code']
  } else {
    code = null
  }

  state = args['state']

  const hasWXUser = appUser.hasWXUser()
  vconsole_log('wechatLogin options', hrefIsBnxgn, options, code, hasWXUser)
  vconsole_log('wechatLogin user', appUser)
  // 【暴虐新概念】有微信用户就可以了
  if (hrefIsBnxgn && hasWXUser) return

  // 【微信用户】如果没有完成登录，重新授权并继续---新放开
  if (hasWXUser) {
    const hash = stateParam.setState(state).getValue('hash')
    // getUserInfo = user || login
    options.hash = hash
    return appUser.isNotUserToLogin(options)
  }

  // 请求授权、获取授权用户
  const authorize = () => {
    appUser.showStep({ message: '获取微信授权', action: 'authorize' })
    // 请求授权(跳转到微信授权地址)
    const localhost = location.host.indexOf('localhost') >= 0
    let redirectUrl = localhost // TODO 微信授权地址------
      ? `https://new-wx.ylyk.com/test/mergeAcount.html#/mergeAcount`
      : // ? 'https://new-wx.ylyk.com/payment.html?shareCode=Z29vZHNJZD0yNDA0OCZ1c2VySWQ9MQ==#/goods'
        location.href
    redirectUrl = setURISearchParams(redirectUrl, 'getcode', '1')
    redirectUrl = encodeURIComponent(redirectUrl)
    const hash = location.hash.substr(1)
    storage.loginNextHash().setItem(hash) // 记住业务路由
    state = stateParam
      .setValue('hash', hash) // .setValue('getcode', 1)
      .getState() // 保存到 state
    // 获取微信授权地址
    wechatService
      .authorize(redirectUrl, state)
      .then(href => {
        console.log('微信授权回参------------', href)
        href = href.replace('&state=state', '&state=' + state)
        vconsole_log('[WXLogin] location.href', decodeURIComponent(href))
        if (getcode_test === 'stop') {
          return
        }
        location.href = href // 记住页面路由
      })
      .catch(() => {
        // Toast('微信登录：授权失败> ' + JSON.stringify(err))
      })
  }
  console.log(code, 'codecodecode')
  if (code == null) {
    appUser.showStep({ message: 'wxcode: ' + code, action: 'authorize' })
    return authorize()
  } else if (code) {
    console.log('我在这里getcode_test：' + getcode_test + '---' + code)
    // 调试code
    if (getcode_test) {
      if (getcode_test === '1') {
        location.href = setURISearchParams(location.href, 'getcode_test', code)
      }
      return
    }
    appUser.wxcode = code
    appUser.showStep({ message: 'wxcode: ' + code, action: 'getWXUserInfoBefor' })

    // return getWXUserInfo(code) // 延迟到组件初始化时
  }
}

export function getWXUserInfo(options) {
  appUser.showStep({ message: '获取微信用户', action: 'getUserInfo' })
  // 读取页面路由
  if (state) {
    const hash = stateParam.getValue('hash')
    if (hash) storage.replace(hash) // 从 state 获取
  }

  // 获取授权用户

  if (copyCode !== undefined) {
    MessageBox.prompt('微信 code', code)
    return
  }
  options = options || {}
  console.log('[getWXUserInfo] options: ', JSON.stringify(options))
  if (code) {
    options.code = code
  }
  // 第二次请求，去掉 openId
  if (options.num === 2) {
    options.openId = null
  }
  return wechatService
    .getUserInfo(options)
    .then(data => {
      saTrack('wxGetUserInfo', {
        code: options.code,
        ...data,
        result: '公众号获取用户信息'
      })
      // 本地保存(已保存)
      if (data.openId || data.token) {
        appUser.setWeixinUser(data)
        const needToLoginPage =
          location.hash !== '#/pullnew' &&
          location.hash !== '#/pullnew2023' &&
          location.hash !== '#/pullnew/detail' &&
          location.hash === '#/confirm-pay' // 新用户拉新页面只获取微信的信息 不用去登录页面注册登录
        console.log('needToLoginPage', location.hash)
        if (appUser.hasWXUser() && needToLoginPage) {
          const options = storage.loginNextAction().getItem()
          appUser.isNotUserToLogin(options)
        }
      }
      return data
    })
    .catch(error => {
      vconsole_log('getUserInfo=>error', error)
      saTrack('wxGetUserInfo', {
        code: options.code,
        errorCode: error.code,
        message: error.message,
        result: '公众号获取用户信息===失败失败'
      })
      const { code } = error
      // error.data.changeCode 微信登录授权触发多账号
      // 10026 10027  需要合并账号
      if (error.data && error.data.changeCode) {
        sessionStorage.setItem('wxMergeRebackUrl', location.href)
        window.location.href = error.data.changeUrl
        return
      }
      // 账户异常
      console.log(error.code == 30109, error.code === 30109)
      if (error.code === 30109) {
        // 跳转小程序添加班主任
        MessageBox({
          title: '',
          message: error.message,
          confirmButtonText: '确定',
          confirmButtonColor: '#00B25A'
        }).then(() => {
          if (appUser.isNative) {
            // APP内
            getMiniParam().then(mini => {
              $gotoMiniProgram({
                miniUserName: mini.miniUserName,
                goMiniUrl: 'pages/rights_receive/app_add_headTeacher/app_add_headTeacher'
              })
            })
          } else {
            // h5访问
            storage.AccountErrorInfo().setItem(error)
            const url = getPageUrl({
              page: 'payment.html',
              route: '/accountError'
            })
            location.href = url
          }
        })

        return
      }

      if (copyCode) {
        Toast({ message: JSON.stringify(error), position: 'bottom' })
      }
      if (!code) return

      // 错误code
      if (copyErrorCode !== undefined) {
        MessageBox.prompt('错误 code', code)
      }

      let errorCode = error.code
      const errorCodes = [
        40000,
        10033, // code been used
        10031 // 微信登录失败
      ]
      if (error.data) {
        errorCodes.forEach(c => {
          if (error.data[c]) {
            errorCode = c
          }
        })
      }
      if (errorCodes.indexOf(errorCode) >= 0) {
        // 重新获取 getUserInfo，所以要清除本地缓存
        // 延迟登录的页面，出现code失效，需要再次调用
        appUser.resetToken()
        appUser.clearWeixinCode()
        const options = { refreshCode: true }
        wechatLogin(options)
        console.log('getWXUserInfo: error', error)
        // location.href = location.href.replace(`code=${code}&`, '')
      } else {
        Toast({ message: error.message, position: 'middle', duration: 5000 })
      }
      return error
    })
}

// 【开始检查微信登录】
checkIsWeixin()

// 登录适配（APP、微信、浏览器）
export function toLoginView(options) {
  const { action } = options || {}
  // --点击按钮获取授权--
  // --type=button 将跳转到登录视图--
  if (action) {
    storage.loginNextAction().setItem(options) // 记住业务路由
  }
  if (appUser.isNative) {
    appUser.showStep({ message: 'APP登录', action })
    return $toAppLogin(options)
  }
  if (appUser.isWeixin) {
    // 登录成功后，继续自动调用该操作
    appUser.showStep({ message: '微信登录', action })
    return wechatLogin(options)
  }
  if (appUser.isBrowser) {
    appUser.showStep({ message: '账号登录', action })
    return appUser.isNotUserToLogin(options)
  }
}

function loadJS(url, { callback, name } = {}) {
  var script = document.createElement('script')

  var fn =
    callback ||
    function () {
      if (name) {
        const module = window.loadModules[name]
        if (module && module.callback) {
          module.callback()
        }
        window.loadModules[name] = true
      }
    }

  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        fn()
      }
    }
  } else {
    // 其他浏览器
    script.onload = function () {
      fn()
    }
  }

  script.src = url
  script.type = 'text/javascript'
  document.getElementsByTagName('head')[0].appendChild(script)
}

// CSS样式
document.addEventListener('DOMContentLoaded', function () {
  var { style, clientWidth } = document.documentElement
  // if (clientWidth < 1000) {
  style.fontSize = clientWidth / 7.5 + 'px'
  // } else {
  //   style.fontSize = '50px';
  // }
})
